var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 20C40.0002 31.0456 31.0459 40 20.0002 40C8.95462 40 0.000244141 31.0456 0.000244141 20C0.000244141 20.0048 20.0002 0.0021875 20.0002 0C31.0459 0 40.0002 8.95437 40.0002 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9466 20H20.0001C20.0001 19.9821 20.0001 19.9646 20.0001 19.9465C19.9823 19.9644 19.9645 19.9822 19.9466 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 10.4348C20.0002 6.91563 20.0002 4.60977 20.0002 0H19.9969C8.95274 0.001875 0.000244141 8.95539 0.000244141 20H10.435V14.1241L16.3109 20H19.9468C19.9646 19.9822 19.9825 19.9644 20.0003 19.9465C20.0003 18.5991 20.0003 17.3968 20.0003 16.3108L14.1243 10.4348H20.0002Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1183 2.60864C6.99028 4.38981 4.38981 6.99028 2.60864 10.1183V20H7.82607V7.82622V7.82606H20C20 6.18052 20 4.61286 20 2.60864H10.1183Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 17.5405L12.8944 10.4348C12.8944 10.4348 10.4349 10.435 10.4349 10.4348V10.435L20 20H20.0001C20.0001 20 20.0001 18.3041 20.0001 17.5405Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.635 14.8405L35.0667 16.169H36.4636L35.3335 16.9901L35.7652 18.3187L34.635 17.4976L33.5048 18.3187L33.9365 16.9901L32.8063 16.169H34.2032L34.635 14.8405Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6415 24.4057L30.289 26.3987H32.3844L30.6891 27.6302L31.3368 29.6231L29.6415 28.3915L27.9462 29.6231L28.5938 27.6302L26.8985 26.3987H28.9939L29.6415 24.4057Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8301 8.75354L30.3698 10.4144H32.1159L30.7031 11.4406L31.2428 13.1014L29.8301 12.0749L28.4174 13.1014L28.957 11.4406L27.5444 10.4144H29.2905L29.8301 8.75354Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0251 14.7825L25.6726 16.7754H27.7681L26.0728 18.007L26.7205 19.9999L25.0251 18.7683L23.3298 19.9999L23.9775 18.007L22.2822 16.7754H24.3776L25.0251 14.7825Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/new_zealand.82d3d4f717f8e5cfaf23beffd8c56851.svg";
export { ForwardRef as ReactComponent };